import { supabase } from '@/core/database/supabase';
import type { 
  ConstructionProgressLog, 
  ProgressFilters 
} from '../types/construction-progress.types';

export const ConstructionProgressLogsService = {
  async getProgressLogs(companyId: string, filters: ProgressFilters = {}): Promise<{ data: ConstructionProgressLog[], total: number }> {
    let query = supabase
      .from('progress_logs')
      .select(`
        *,
        project:projects(id, name),
        zone:project_zones(id, zone_name),
        team:teams(id, name, code),
        reporter:user_profiles!created_by(id, full_name, avatar_url:avatar_path)
      `, { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.status && filters.status !== 'all') query = query.eq('status_code', filters.status);
    if (filters.projectId) query = query.eq('project_id', filters.projectId);
    if (filters.zoneId) query = query.eq('zone_id', filters.zoneId);
    if (filters.teamId) query = query.eq('team_id', filters.teamId);
    if (filters.date) query = query.eq('log_date', filters.date);
    if (filters.search) {
      query = query.or(`summary.ilike.%${filters.search}%`);
    }

    query = query.order('log_date', { ascending: false });

    const { data, error, count } = await query;

    if (error) throw error;
    return {
      data: (data || []) as ConstructionProgressLog[],
      total: count || 0
    };
  },

  async getProgressLogDetail(id: string): Promise<ConstructionProgressLog> {
    const { data, error } = await supabase
      .from('progress_logs')
      .select(`
        *,
        project:projects(id, name),
        zone:project_zones(id, zone_name),
        team:teams(id, name, code),
        reporter:user_profiles!created_by(id, full_name, avatar_url:avatar_path)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as ConstructionProgressLog;
  },

  async createLog(data: Partial<ConstructionProgressLog>): Promise<ConstructionProgressLog> {
    const { data: result, error } = await supabase
      .from('progress_logs')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionProgressLog;
  },

  async updateLog(id: string, updates: Partial<ConstructionProgressLog>): Promise<void> {
    const { error } = await supabase
      .from('progress_logs')
      .update(updates)
      .eq('id', id);

    if (error) throw error;
  }
};

